import { createBrowserRouter, Navigate } from "react-router-dom";
import PaginaNaoEncontrada from "../components/pages/PaginaNaoEncontrada/PaginaNaoEncontrada";
import Login from "../components/pages/Login/Login";
import ForcePasswordChange from "../components/pages/Login/ForcePasswordChange";
import RecuperarSenha from "../components/pages/RecuperarSenha/RecuperarSenha";
import App from "../App";
import ProtectedRoute from "./ProtectedRoute";
import RegistrationPage from "../components/pages/RegistrationPage/RegistrationPage";
import ConfirmacaoDados from "../components/pages/ConfirmacaoDados/ConfirmacaoDados";
import UserAdminPage from "../components/pages/UserAdminPage/UserAdminPage";
import { CadastroProvider } from "../resources/CadastroProvider";
import VisualizacaoDadosUsuario from "../components/pages/VisualizacaoDadosUsuario/VisualizacaoDadosUsuario";
import VisualizarAlteracoes from "../components/pages/VisualizarAlteracoes/VisualizarAlteracoes";
import Dashboard from "../components/pages/Dashboard/Dashboard";
import AdminConfigPage from "../components/pages/AdminConfigPage/AdminConfigPage";
import PolosConfigPage from "../components/pages/AdminConfigPage/PolosConfigPage";
import TematicasConfigPage from "../components/pages/AdminConfigPage/TematicasConfigPage";
import GestaoParceiros from "../components/pages/GestaoParceirosPage/GestaoParceiros";
import NewParceiro from "../components/pages/GestaoParceirosPage/NewParceiro";
import GestaoColaboradores from "../components/pages/GestaoColaboradores/GestaoColaboradores";
import NewColaborador from "../components/pages/GestaoColaboradores/NewColaborador";
import ListarAcoes from "../components/pages/AcoesQualificacao/ListarAcoes";
import CadastrarAcao from "../components/pages/AcoesQualificacao/CadastrarAcao";
import { GestaoTurmas, EditarTurma, ControlePresenca, CadastroParticipanteTurma } from "../components/pages/Turmas";
import PresencaTurma from "../components/pages/Turmas/PresencaTurma";
import AcoesDisponiveis from "components/pages/InscricaoAcao/AcoesDisponiveis";
import OrientacaoAcao from "components/pages/InscricaoAcao/OrientacaoAcao";
import EscolherTurma from "components/pages/InscricaoAcao/EscolherTurma";
import GerenciarInscricao from "components/pages/GerenciarInscricao/GerenciarInscricao";
import GestaoPaginas from "../components/pages/GestaoPaginas/GestaoPaginas";
import NovaPagina from "../components/pages/GestaoPaginas/NovaPagina";
import GestaoModulos from "../components/pages/GestaoModulos/GestaoModulos";
import GestaoAcoesPermissao from "../components/pages/GestaoAcoesPermissao/GestaoAcoesPermissao";
import GestaoPerfis from "../components/pages/GestaoPerfis/GestaoPerfis";
import NovoPerfil from "../components/pages/GestaoPerfis/NovoPerfil";
import PermissoesPerfil from "../components/pages/GestaoPerfis/PermissoesPerfil";
import CadastrarModeloCertificado from "../components/pages/ModeloCertificado/CadastrarModeloCertificado";
import CertificadosDeclaracoesAdmin from "../components/pages/ModeloCertificado/CertificadosDeclaracoesAdmin";
import PesquisasSatisfacao from "../components/pages/ModeloPesquisa/PesquisasSatisfacao";
import CadastrarModeloPesquisa from "../components/pages/ModeloPesquisa/CadastrarModeloPesquisa";
import { CertificadosDeclaracoes, EmitirCertificado } from "../components/pages/Certificados";
import ValidarCertificado from "../components/pages/Certificados/ValidarCertificado";
import Relatorios from "../components/pages/Relatorios/Relatorios";
import ParametrizacaoCampos from "../components/pages/ParametrizacaoCampos/ParametrizacaoCampos";

function Home() {
  return <Dashboard />;
}
function About() {
  return <h2>Aqui você aprende o que é o SISCAP</h2>;
}
function Contact() {
  return <h2>Uma lista de Contantos</h2>;
}
function Livre() {
  return <h2>Uma pagina Livre pra qualquer usario</h2>;
}

const appBrowserRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <PaginaNaoEncontrada />,
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute url="/">
            <Home />
          </ProtectedRoute>
        ),
      },
      {
        path: "/about",
        element: (
          <ProtectedRoute url="/about">
            <About />
          </ProtectedRoute>
        ),
      },
      {
        path: "/contact",
        element: (
          <ProtectedRoute url="/contact">
            <Contact />
          </ProtectedRoute>
        ),
      },
      {
        path: "/livre",
        element: <Livre />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/recuperar-senha",
        element: <RecuperarSenha />,
      },
      {
        path: "/user-list",
        element: (
          <ProtectedRoute url="/user-list">
            <UserAdminPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/partners",
        element: (
          <ProtectedRoute url="/partners">
            <GestaoParceiros />
          </ProtectedRoute>
        ),
      },
      {
        path: "/partner",
        element: (
          <ProtectedRoute url="/partner">
            <NewParceiro />
          </ProtectedRoute>
        ),
      },
      {
        path: "/colaboradores",
        element: (
          <ProtectedRoute url="/colaboradores">
            <GestaoColaboradores />
          </ProtectedRoute>
        ),
      },
      {
        path: "/colaborador",
        element: (
          <ProtectedRoute url="/colaborador">
            <NewColaborador />
          </ProtectedRoute>
        ),
      },
      {
        path: "/nova-acao",
        element: (
          <ProtectedRoute url="/nova-acao">
            <CadastrarAcao />
          </ProtectedRoute>
        ),
      },
      {
        path: "/editar-acao",
        element: (
          <ProtectedRoute url="/editar-acao">
            <CadastrarAcao />
          </ProtectedRoute>
        ),
      },
      {
        path: "/acoes-qualificacao",
        element: (
          <ProtectedRoute url="/acoes-qualificacao">
            <ListarAcoes />
          </ProtectedRoute>
        ),
      },
      {
        path: "/gestao-turmas",
        element: (
          <ProtectedRoute url="/gestao-turmas">
            <GestaoTurmas />
          </ProtectedRoute>
        ),
      },
      {
        path: "/editar-turma",
        element: (
          <ProtectedRoute url="/editar-turma">
            <EditarTurma />
          </ProtectedRoute>
        ),
      },
      {
        path: "/controle-presenca",
        element: (
          <ProtectedRoute url="/controle-presenca">
            <ControlePresenca />
          </ProtectedRoute>
        ),
      },
      {
        path: "/controle-presenca/cadastrar-participante",
        element: (
          <ProtectedRoute url="/controle-presenca">
            <CadastroParticipanteTurma />
          </ProtectedRoute>
        ),
      },
      {
        path: "/presenca-turma",
        element: <PresencaTurma />,
      },
      {
        path: "/validar-certificado",
        element: <ValidarCertificado />,
      },
      {
        path: "/realizar-inscricao",
        element: (
          <ProtectedRoute url="/realizar-inscricao">
            <AcoesDisponiveis />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orientacao-acao",
        element: (
          <ProtectedRoute url="/orientacao-acao">
            <OrientacaoAcao />
          </ProtectedRoute>
        ),
      },
      {
        path: "/escolher-turma",
        element: (
          <ProtectedRoute url="/escolher-turma">
            <EscolherTurma />
          </ProtectedRoute>
        ),
      },
      {
        path: "/gerenciar-inscricoes",
        element: (
          <ProtectedRoute url="/gerenciar-inscricoes">
            <GerenciarInscricao />
          </ProtectedRoute>
        ),
      },
      {
        path: "/certificados-declaracoes",
        element: (
          <ProtectedRoute url="/certificados-declaracoes">
            <CertificadosDeclaracoes />
          </ProtectedRoute>
        ),
      },
      {
        path: "/emitir-certificado",
        element: (
          <ProtectedRoute url="/certificados-declaracoes">
            <EmitirCertificado />
          </ProtectedRoute>
        ),
      },
      {
        path: "/relatorios",
        element: (
          <ProtectedRoute url="/relatorios">
            <Relatorios />
          </ProtectedRoute>
        ),
      },
      {
        path: "/parametrizacao-campos",
        element: (
          <ProtectedRoute url="/parametrizacao-campos">
            <ParametrizacaoCampos />
          </ProtectedRoute>
        ),
      },
      {
        path: "/modulos",
        element: (
          <ProtectedRoute url="/modulos">
            <GestaoModulos />
          </ProtectedRoute>
        ),
      },
      {
        path: "/acoes-permissao",
        element: (
          <ProtectedRoute url="/acoes-permissao">
            <GestaoAcoesPermissao />
          </ProtectedRoute>
        ),
      },
      {
        path: "/paginas",
        element: (
          <ProtectedRoute url="/paginas">
            <GestaoPaginas />
          </ProtectedRoute>
        ),
      },
      {
        path: "/nova-pagina",
        element: (
          <ProtectedRoute url="/nova-pagina">
            <NovaPagina />
          </ProtectedRoute>
        ),
      },
      {
        path: "/perfis",
        element: (
          <ProtectedRoute url="/perfis">
            <GestaoPerfis />
          </ProtectedRoute>
        ),
      },
      {
        path: "/novo-perfil",
        element: (
          <ProtectedRoute url="/novo-perfil">
            <NovoPerfil />
          </ProtectedRoute>
        ),
      },
      {
        path: "/permissoes",
        element: (
          <ProtectedRoute url="/permissoes">
            <PermissoesPerfil />
          </ProtectedRoute>
        ),
      },
      {
        path: "/modelos-certificados",
        element: (
          <ProtectedRoute url="/modelos-certificados">
            <CertificadosDeclaracoesAdmin />
          </ProtectedRoute>
        ),
      },
      {
        path: "/modelos-pesquisa",
        element: (
          <ProtectedRoute url="/modelos-pesquisa">
            <PesquisasSatisfacao />
          </ProtectedRoute>
        ),
      },
      {
        path: "/cadastrar-modelo-pesquisa",
        element: (
          <ProtectedRoute url="/cadastrar-modelo-pesquisa">
            <CadastrarModeloPesquisa />
          </ProtectedRoute>
        ),
      },
      {
        path: "/cadastrar-modelo-certificado",
        element: (
          <ProtectedRoute url="/cadastrar-modelo-certificado">
            <CadastrarModeloCertificado />
          </ProtectedRoute>
        ),
      },
      {
        path: "/cadastro",
        element: (
          <CadastroProvider>
            <RegistrationPage />
          </CadastroProvider>
        ),
      },
      {
        path: "/cadastro/:step",
        element: <Navigate to="/cadastro" replace />,
      },
      {
        path: "/admin-cadastro",
        element: (
          <ProtectedRoute url="/admin">
            <CadastroProvider>
              <RegistrationPage />
            </CadastroProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: "/admin-cadastro/:step",
        element: <Navigate to="/admin-cadastro" replace />,
      },
      {
        path: "/confirmardados",
        element: (
          <CadastroProvider>
            <ConfirmacaoDados />
          </CadastroProvider>
        ),
      },
      {
        path: "/changes-list",
        element: (
          <ProtectedRoute url="/changes-list">
            <VisualizarAlteracoes />
          </ProtectedRoute>
        ),
      },
      {
        path: "/user",
        element: (
          <ProtectedRoute url="/user">
            <CadastroProvider>
              <VisualizacaoDadosUsuario />
            </CadastroProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: "/editar-perfil",
        element: (
          <ProtectedRoute url="/editar-perfil" requirePermissionCheck={false}>
            <CadastroProvider>
              <VisualizacaoDadosUsuario />
            </CadastroProvider>
          </ProtectedRoute>
        ),
      },
      {
        path: "/adminconfigpage",
        element: (
          <ProtectedRoute url="/adminconfigpage">
            <AdminConfigPage />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "polos",
            element: <PolosConfigPage />,
          },
          {
            path: "tematicas",
            element: <TematicasConfigPage />,
          },
        ],
      },
    ],
  },
  {
    path: "/alterar-senha-obrigatoria",
    element: (
      <ProtectedRoute url="/alterar-senha-obrigatoria" requirePermissionCheck={false}>
        <ForcePasswordChange />
      </ProtectedRoute>
    ),
  },
]);

export default appBrowserRouter;
